import { Loader2, MapPin } from "lucide-react";
import {
  JourneyChoiceGrid as ChoiceGrid,
  JourneyField as Field,
  JourneyTextInput as TextInput,
} from "../controls";

export const LocationStep = ({ answers, onLocationChange, onFindOptions, locationChoices, locationMessage, locationLoading, onSelectPreference, update }) => {
  if (answers.current_location === "outside_uk") {
    return (
      <div>
        <h2 className="font-display text-3xl font-bold tracking-tight text-ink">Where are you based?</h2>
        <p className="mt-2 text-sm leading-6 text-slatey">OpenDegree will show opportunities that welcome international learners, plus online options you can join from where you are.</p>
        <div className="mt-6 grid gap-5 md:grid-cols-2">
          <Field label="Which country are you in?"><TextInput value={answers.outside_country} onChange={(v) => update("outside_country", v)} placeholder="For example: Romania" testId="journey-outside-country" /></Field>
          <Field label="City or area (optional)"><TextInput value={answers.outside_city} onChange={(v) => update("outside_city", v)} placeholder="For example: Suceava" testId="journey-outside-city" /></Field>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h2 className="font-display text-3xl font-bold tracking-tight text-ink">Where are you based?</h2>
      <p className="mt-2 text-sm leading-6 text-slatey">OpenDegree uses this to understand your geographic position and the opportunities available within a reasonable travel area — locally first, then nearby towns and cities, then online.</p>
      <div className="mt-6 grid gap-5 md:grid-cols-[1fr_auto] md:items-end">
        <Field label="Town, city or postcode" help="For example: Warrington, Manchester or WA1. This is not stored beyond this session unless you later create an account.">
          <TextInput value={answers.location} onChange={onLocationChange} placeholder="Where are you based?" testId="journey-location-input" />
        </Field>
        <button onClick={onFindOptions} disabled={!answers.location || locationLoading} data-testid="journey-location-find"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-cobalt px-5 py-3.5 text-sm font-bold text-white disabled:opacity-50">
          {locationLoading ? <Loader2 className="h-4 w-4 animate-spin" /> : <MapPin className="h-4 w-4" />} See location options
        </button>
      </div>

      {locationMessage && <p className="mt-4 rounded-2xl border border-amber-200 bg-amber-50 p-4 text-sm leading-6 text-amber-800" data-testid="journey-location-message">{locationMessage}</p>}

      {locationChoices.length > 0 && (
        <div className="mt-6">
          <Field label="Where would you like to study?" help="Nearby areas are based on real OpenDegree opportunity locations and their distance from you.">
            <ChoiceGrid options={locationChoices} value={answers.location_preference} onChange={onSelectPreference} testId="journey-location-pref" />
          </Field>
        </div>
      )}
    </div>
  );
};
